import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ScrollingModule } from "@angular/cdk/scrolling";

import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatToolbarModule } from "@angular/material/toolbar";

import { TourAnchorMatMenuDirective } from "ngx-ui-tour-md-menu";
import { MatSidenavModule } from "@angular/material/sidenav";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenNavComponent } from "./components/loren-nav/loren-nav.component";
import { LorenLanguageSwitcherComponent } from "./components/loren-nav/components/loren-language-switcher/loren-language-switcher.component";
import { LorenSidenavComponent } from "./components/loren-nav/components/loren-sidenav/loren-sidenav.component";
import { LorenUserMenuComponent } from "./components/loren-nav/components/loren-user-menu/loren-user-menu.component";
import { LorenDateModule } from "../../pipes/loren-date/loren-date.module";
import { LorenUserInitialsPipe } from "./components/loren-nav/pipes/loren-user-initials/loren-user-initials.pipe";
import { LorenTrimModule } from "../../pipes/loren-trim/loren-trim.module";
import { LorenBottomSheetModule } from "../loren-bottom-sheet/loren-bottom-sheet.module";
import { LorenSharedDirectivesModule } from "../../directives/loren-shared-directives.module";
import { LorenShowForRoleDirective } from "../../directives/loren-show-for-role-directive/loren-show-for-role.directive";
import { LorenToolbarComponent } from "./components/loren-nav/components/loren-toolbar/loren-toolbar.component";
import { LorenNotificationsButtonComponent } from "./components/loren-nav/components/loren-notifications-button/loren-notifications-button.component";
import { LorenSettingsMenuComponent } from "./components/loren-nav/components/loren-settings-menu/loren-settings-menu.component";
import { LorenHelpButtonComponent } from "./components/loren-nav/components/loren-help-button/loren-help-button.component";
import { LorenImpersonationBannerComponent } from "./components/loren-nav/components/loren-impersonation-banner/loren-impersonation-banner.component";

@NgModule({
  declarations: [
    LorenNavComponent,
    LorenLanguageSwitcherComponent,
    LorenSidenavComponent,
    LorenUserMenuComponent,
    LorenUserInitialsPipe,
    LorenToolbarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ScrollingModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatListModule,
    MatSelectModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    TranslocoModule,
    TourAnchorMatMenuDirective,

    LorenDateModule,
    LorenTrimModule,
    LorenBottomSheetModule,
    LorenSharedDirectivesModule,

    LorenNotificationsButtonComponent,
    LorenSettingsMenuComponent,
    LorenHelpButtonComponent,
    LorenImpersonationBannerComponent,
    ReactiveFormsModule,
  ],
  exports: [
    LorenNavComponent,
    LorenLanguageSwitcherComponent,
    LorenSidenavComponent,
    LorenUserMenuComponent,
    LorenUserInitialsPipe,
  ],
  providers: [
    LorenUserInitialsPipe,
    LorenShowForRoleDirective,
  ],
})
export class LorenNavModule {}
